import { Box, Button, Card, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Page from 'app/layout/Page'

import { MicroSiteLinkButton } from '../micro-site-link-button/MicroSiteLinkButton'

export interface AdminFreeResourcesCardProps {
  resourceAsset: string | undefined
  isSuperAdmin: boolean
  isFetching: boolean
  onEditClick: () => void
}

export const AdminFreeResourcesCard = ({
  resourceAsset,
  isSuperAdmin,
  isFetching,
  onEditClick,
}: AdminFreeResourcesCardProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'engagementResourcesPage' })
  const showHint = isSuperAdmin && !resourceAsset && !isFetching

  return (
    <Page>
      <Typography variant="h1" data-testid="engagement-resources-title">
        {t('title')}
      </Typography>
      <Card
        data-testid="engagement-resources-section"
        sx={{
          mt: 3,
          display: 'flex',
          padding: '20px 16px',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '16px',
          alignSelf: 'stretch',
          boxShadow: '0 2px 4px 0 rgba(188, 188, 188, 0.50)',
        }}
      >
        <Box
          sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: 1 }}
        >
          <Typography variant="h2" data-testid="engagement-resources-section-title">
            {t('freeResources.title')}
          </Typography>
          {isSuperAdmin && (
            <Button
              data-testid="engagement-resources-edit-button"
              onClick={onEditClick}
              variant="outlined"
              disabled={isFetching}
              sx={{
                height: 40,
                color: '#373736',
                borderColor: '#373736',
                '&:hover': { borderColor: '#373736', backgroundColor: 'transparent' },
              }}
            >
              {t('freeResources.edit')}
            </Button>
          )}
        </Box>
        <Typography
          variant="body1"
          data-testid="engagement-resources-section-description"
          sx={{ alignSelf: 'stretch' }}
        >
          {t('freeResources.description')}
        </Typography>
        <MicroSiteLinkButton resourceAsset={resourceAsset} showHint={showHint} />
      </Card>
    </Page>
  )
}
